<p-confirmPopup></p-confirmPopup>
<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="search-data">
</div>
<div class="date-filter">
  <div class="grid">

    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="name">Name</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input id="name" type="text" pInputText placeholder="Enter Name" [(ngModel)]="name" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="mobile">Mobile Number</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input id="mobile" type="text" pInputText placeholder="Enter Mobile Number" [(ngModel)]="phoneNumber"
              (keypress)="onlyNumber($event)" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="email">Email</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input id="email" type="text" pInputText placeholder="Enter Email" [(ngModel)]="email" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="paymentStatus">Payment Status</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <p-dropdown id="paymentStatus" [options]="selectStatus" (onChange)="onChangePaymentStatus($event)" placeholder="Select Status"
              [(ngModel)]="searchStatus" optionLabel="name" optionValue="id" optionValue="value"></p-dropdown>
            <img src="../../../../assets/images/fill-dropdown.svg" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-2">
      <div class="date-outer">
        <label for="invoiceNumber">Invoice Number</label>
        <div class="custom-select2">
          <div class="filter-parking header-filter">
            <input id="invoiceNumber" type="text" pInputText placeholder="Enter Invoice Number" [(ngModel)]="invoiceNumber" />

</div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-1">
      <div class="date-outer-btn">
        <div class="edit-outer">
          <p-button styleClass="p-button search-button" label="Search"
            (onClick)="getParkingLotInvoiceForDriver('search')"></p-button>

</div>

      </div>
    </div>
    <div class="col-12 lg:col-1">
      <div class="date-outer-btn">
        <div class="edit-outer reset-btn">
          <p-button styleClass="p-button p-button-outlined" label="Reset" (onClick)="resetFilter()"></p-button>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="driver-list-outer">
  <div class="list-heading">
    <h4>Invoice List - Custom Invoices</h4>
    <div class="record-outer">
      <div class="page-list filter-parking record-inner">
        <div class="records-outer">
          <span>Show</span>
          <div class="records-inner"><p-dropdown [options]="CustomItemPerPageBy" (onChange)="onDropdownChange($event)"
              placeholder="10" optionLabel="name" optionValue="value"
              [(ngModel)]="SearchItemPerPageBy"></p-dropdown><img src="assets/images/fill-dropdown.svg" alt=""/>
         
          </div>
          <span>Records</span> 

        </div>
    
        <div (click)="exportMenu();menu.toggle($event)" class="three-dots">
          <img src="assets/images/dashboard-dot.svg" alt="" />
        </div>
    
    </div>
  </div>
  </div>
  <div class="card parking-list fullwidth-table-scroll common-heighttd booking-outer"
    [class.parking-list]="invoiceList?.length>0">

    <p-table id="tbl-top" [value]="invoiceList" [resizableColumns]="true" columnResizeMode="expand">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" class="custom-addres">Name</th>
          <th scope="col">Invoice Number</th>
          <th scope="col">Email</th>
          <th scope="col">Mobile Number</th>
          <th scope="col">User Type</th>
          <th scope="col">Company</th>
          <th scope="col" class="invoice-lots">Parking Lot</th>
          <th scope="col">Arrival Date & Time</th>
          <th scope="col">Departure Date & Time</th>
          <th scope="col">Time Zone</th>
          <th scope="col">Generated By</th>
          <th scope="col">Invoice Date</th>
          <th scope="col">Created Date</th>
          <th scope="col">Amount ($)</th>
          <th scope="col">Payment Mode</th>
          <th scope="col">Payment Status</th>
          <th scope="col">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr class="border12">
          <td class="driver-name custom-driver-name" (click)="goToCrmPage(rowData)">
            <div class="history-table invoice-list-name">
              <img [src]="rowData.profilePicture || 'assets/images/dummy-img.png'" alt="Profile" />
              <p>{{ rowData.userType === 'Group Operator' ? rowData.groupName :
                rowData.name }}</p>
            </div>
          </td>
          <td>{{rowData.invoiceNumber}}</td>
          <td>{{rowData.email}}</td>
          <td>
            <div class="mobile-number"><span *ngIf="rowData?.phoneNumber" [ngClass]="getFlagClass(rowData?.iso)"></span>
              {{ rowData?.phoneNumber ? rowData.countryCode + ' ' + rowData.phoneNumber : '-' }}</div>
          </td>
          <td>{{rowData.userType}}</td>
          <td>{{rowData.company}}</td>
          <td>
            <p class="parking-lot-text">{{rowData.parkingLotName}}<br>
              {{rowData.address}}</p>
          </td>
          <td>{{rowData.arrivalDate || '-' }}</td>
          <td>{{rowData.departureDate || '-'}}</td>
          <td>
            <div class="big-parking">
              <p>{{rowData.timeZone ? (getTimeZoneAbbreviation(rowData?.timeZone)) : '-'}}</p>
            </div>
          </td>
          <td>{{rowData.generatedBy}}</td>
          <td>{{ rowData.billingDate.split('|')[0].trim()}}</td>
          <td>{{rowData.dateCreated}}</td>
          <td class="last-col">{{rowData.totalAmount}}</td>
          <td>{{rowData.bookingPaymentMode | paymentModeValue}}</td>
          <td>
            <div class="big-parking">
              <p class="common-payment-status" [ngClass]="rowData.paymentStatus | invoicePaymentStatus">
                {{rowData.status}}
                <span
                  *ngIf="rowData?.paymentFailureError && rowData.paymentStatus === invoicePaymentStatus.PaymentFailed"><em
                    class="pi pi-info-circle" [pTooltip]="rowData?.paymentFailureError"
                    tooltipPosition="top"></em></span>
              </p>
            </div>
          </td>
          <td>
            <div class="export-btn">
              <img (click)="activeItem = rowData;showData(rowData,$event);menu.toggle($event)"
                src="assets/images/dashboard-dot.svg" alt="" />
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-border">
          <td class="no-record" colspan="16">
            No Record Found
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
  <div class="card common-content-end custom-pagination1" *ngIf="invoiceList?.length > 0">
    <p-paginator [first]="currentSkip" [rows]="itemsPerPage" [totalRecords]="totalRecords"
      (onPageChange)="onPageChange($event)"></p-paginator>

  </div>
</div>
<div [ngClass]="{'export-btn': !isAlternateDesign, 'custom-export': isAlternateDesign }">
  <p-menu #menu [model]="items" [popup]="true"></p-menu>
</div>